module.exports = __webpack_public_path__ + "static/img/blue_animate4.b7c6a09d.png";